<template>
  <v-container fluid class="pa-0">

    <v-progress-linear v-if="loading" indeterminate height="1"></v-progress-linear>
    <!-- <v-divider v-else style="border-color: rgb(151 151 151 / 12%);" /> -->

    <RouteListItem v-for="(contractType, index) in typeList" :key="index" :node="{
      name: 'Contracts',
      meta: {
        displayName: contractType.Name,
        icon: getTypeIcon(contractType.Id),
        count: contractType.Count,
        params: { contractTypeId: contractType.Id },
      }
    }">
    </RouteListItem>

    <v-divider class="mx-4" style="border-color: rgb(151 151 151 / 12%);" />

  </v-container>
</template>


<script>
import RouteListItem from "@/components/SingleUse/ComponentOverrides/sidebar/RouteListItem_Base.vue";
import ContractMixin from "@/helpers/Mixins/ContractMixin";

export default {
  name: "RouteListItem_ContractLists",
  props: {
    node: Object,
  },
  components: {
    RouteListItem,
  },
  mixins: [ContractMixin],

  data() {
    return {

    };
  },

  methods: {
    getTypeIcon(typeId) {
      return this.getContractTypeIcon(typeId); //from mixin
    }
  },

  computed: {
    loading() {
      return this.ContractTypesLoading; //from mixin
    },

    typeList() {
      return this.LicenseFilteredContractTypeList; //from mixin
    },
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>